import { StyleRules } from '@mui/styles';

const styles = (): StyleRules => ({
    formControl: {
        width: '100%',
    },
    select: {
        fontSize: '13px',
        paddingRight: '16px',
    },
    icon: {
        right: '-7px',
    },
    listItem: {
        fontSize: '13px',
    },
    dropDown: {
        fontSize: '13px',
        backgroundColor: '#FFFFFF',
    },
});

export default styles;
